import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {languages} from '../languages.model'
import {I18nService} from "../i18n.service";
import { Subscription } from 'rxjs';
import { EmitService } from '@app/ts/services/emit.service';
import { CommonService } from '@app/shared/common/common.service';
import { environment } from '@env/environment';

declare var $: any;

@Component({
  selector: 'sa-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls:['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {

  public languages: Array<any>;
  public currentLanguage: any;
  reload:boolean=true;
  loadedinConstructor=false;
  langSubscription: Subscription;
  languageListData = languages;
  @ViewChild('languageList') languageList: ElementRef;
  getStatus = false;
  constructor(private i18n: I18nService,private emitService:EmitService,private commonService:CommonService) {
    this.langSubscription = this.emitService.langLoginChange.subscribe(data=>{
      data == null ? data = 'de' : "";
      let userLang = this.languageListData.filter( a => a.key == data);
      this.loadedinConstructor=true;
      this.currentLanguage = userLang[0];
      this.currentLanguage.key=data;
      this.setLanguage(this.currentLanguage);
      this.reload=true;
    });
    /* $(document).on('click',(event)=>{ 
      var x = this.languageList.nativeElement;
      if (x.style.display === "block" && !this.getStatus){
        x.style.display = "none"; 
      }
      this.getStatus = false;
    }); */
  }

  ngOnInit() {
    
    // $(".dropdown-menu").hide();
    // let languageCookie = this.commonService.getCookie(this.commonService.encrypt(environment.languageCookie))
    let lang =  this.commonService.getCookie(this.commonService.encrypt(environment.languageCookie));
    let defaultLang = this.commonService.decrypt(lang)
    if(!this.loadedinConstructor){
      let currentLang = defaultLang?JSON.parse(defaultLang) : localStorage.getEncryptedItem("current_lang") ? JSON.parse(localStorage.getEncryptedItem("current_lang")) : {};
      let language = Object.keys(currentLang).length === 0 && currentLang.constructor === Object ?  this.i18n.currentLanguage : currentLang;
      this.setLanguage(language);
    }
  }
  // JSON.parse(localStorage.getEncryptedItem("current_lang")) : {};
  ngOnDestroy() {
    this.langSubscription.unsubscribe();
  }
  public setLanguage(language){
    let langmap = {"de": "common_language_German", "en": "common_language_English", "fr": "common_language_French"}
    this.reload=false;
    this.languages =  this.i18n.setLanguageData(language.key);
    this.currentLanguage = language;
    console.log(this.currentLanguage);    
    this.i18n.setLanguage(language);
    this.reload=true;
    let lang = {"key": language.key, "alt": langmap[language.key], "title": langmap[language.key]}
    this.commonService.setCookie(this.commonService.encrypt(environment.languageCookie),this.commonService.encrypt(JSON.stringify(language)),10000,'','/')
  }

  showList(e) {
    $(".language-list").toggle();
    this.getStatus = true;
  }
}
